<template>
    <Drawer @onClose="closeCallback">
        <div class="flex items-center justify-between p-4">
            <p class="flex items-center gap-2 text-eureka-500">
                <span class="text-lg" v-show="!companySerIns.loading">{{ companySerIns.total }}</span>
                <span v-html="title" class="text-sm text-black"></span>
            </p>
            <BatchSave v-if="solutionIds.length && !disabledBatchSave" :result="{ solutionIds }" />
        </div>

        <CatLoading v-if="companySerIns.loading" class="mx-auto mt-40" />

        <div v-else-if="companySerIns.isEmpty" class="mt-40 flex justify-center">
            <CatHole2 class="mb-2 h-[50px] w-[70px]" />
            <span class="text-sm text-grey-90">
                {{ t('noData') }}
            </span>
        </div>

        <div v-else class="flex h-full flex-col gap-4 overflow-y-auto px-4 pb-4" ref="rightAside"
             @scroll="handleContentScroll">
            <SolutionCard :with-border="true" :order="index + 1" :solution="item" :footerField="footerField"
                          v-for="(item, index) in companySerIns.list" :key="item.SOLUTION_ID" />
            <div v-if="companySerIns.moreLoading" class="mx-auto">
                <span class="th-loading th-loading-spinner th-loading-md"></span>
            </div>
        </div>
    </Drawer>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { SolutionCard } from '@eureka/shared/solution-card';
import type { IRightListComponentData } from '@/types';
import { Drawer } from '@eureka/shared/drawer'
import { CatLoading, CatHole2 } from '@eureka/cat'
import { CompanyListService } from '@/services/company-list-service';
import { BatchSave } from '@eureka/shared/eureka-save';
import _ from 'lodash';

import { useI18n } from 'vue-i18n';
const { t } = useI18n()

const props = defineProps<{
    title: string;
    closeCallback: () => void;
    data?: IRightListComponentData;
    disabledBatchSave?: boolean;
    footerField?: string;
}>()

const rightAside = ref(null)
const companySerIns = ref(new CompanyListService(rightAside as unknown as HTMLDivElement))

onMounted(() => {
    companySerIns.value.loadInitialData({
        ...props.data,
    })
})

function handleContentScroll() {
    companySerIns.value.handleScroll({
        ...props.data,
    })
}

const solutionIds = computed(() => {
    return _.map(companySerIns.value.list, 'SOLUTION_ID')
})

</script>
